import MainModal from '@/common/components/base/modal/Modal';
import useModal from '@/common/hooks/useModal';
import AdjusterImagesFabModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/AdjusterImagesFabModal';
import { GetFabTabsQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabTabs/getFabTabsQuery.type';
import GalleryIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/galleryIcon.svg?react';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default ({ state }: { state: GetFabTabsQueryParamsType['state'] }) => {
  const {
    open: adjusterOpen,
    openModal: adjusterOpenModal,
    closeModal: adjusterCloseModal,
  } = useModal();

  return (
    <>
      <Box
        className={css({
          position: 'fixed',
          bottom: '5rem',
          left: '1rem',
          zIndex: 'modal',
        })}
        onClick={adjusterOpenModal}
      >
        <GalleryIcon color={token('colors.purple-primary')} />
      </Box>

      <MainModal fullHeight open={adjusterOpen} closeModal={adjusterCloseModal}>
        <AdjusterImagesFabModal state={state} />
      </MainModal>
    </>
  );
};
